import React from "react";
import styled from "styled-components";
import { COLORS } from "../../COLORS";
import { useLocation, useNavigate } from "react-router-dom";
import { Slide } from "react-awesome-reveal";
import { Dynamic } from "../Context/ContextDynamic";

const Header = () => {
  const nav = useNavigate();
  const location = useLocation();
  const { emoji } = Dynamic();
  return (
    <StyledHeader>
      <div className="box-img-emohi">
        <img
          src="/items/fulllogowhite.svg"
          alt="logo-full"
          onClick={() => nav("/")}
        />
        {emoji && (
          <Slide direction="down" className="emoji-box">
            <span className="emoji-header"> {emoji}</span>
          </Slide>
        )}
      </div>
      <nav>
        <ol>
          <li
            onClick={() => nav("/")}
            className={location.pathname === "/" ? "active" : ""}
          >
            Accueil
          </li>
          <li
            onClick={() => nav("/business")}
            className={location.pathname === "/business" ? "local active" : ""}
          >
            Business 🔥
          </li>
          <li
            onClick={() => nav("/annonces")}
            className={
              location.pathname === "/annonces" ||
              location.pathname === "/simples"
                ? "active"
                : ""
            }
          >
            Annonces
          </li>
          <li
            onClick={() => nav("/evenements")}
            className={location.pathname === "/evenements" ? "active" : ""}
          >
            Evenements
          </li>
          {/* <li
            onClick={() => nav("/points")}
            className={location.pathname === "/points" ? "active" : ""}
          >
            Points
          </li> */}
          <li
            onClick={() => nav("/post")}
            className={location.pathname === "/post" ? "active" : ""}
          >
            Publier
          </li>
        </ol>
      </nav>
    </StyledHeader>
  );
};

export default Header;

const StyledHeader = styled.header`
  background: ${COLORS.green};
  /* border-bottom-width: 1px; */
  border-bottom: solid 2px ${COLORS.blue_sky};
  padding: 10px;
  /* margin-bottom: 10px; */
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: space-between;
  .box-img-emohi {
    width: 10%;
    display: flex;
    img {
      display: block;
      width: 100%;
      cursor: pointer;
    }
  }
  nav {
    /* background: red; */
    width: 45%;
    display: flex;
    justify-content: center;
    align-items: center;
    ol {
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      li {
        font-size: 1.2em;
        //font-weight: 700;
        color: ${COLORS.white};
        cursor: pointer;
        transition: 0.3s;
      }
      li:hover {
        color: ${COLORS.border_and_text_blue};
      }
      .active {
        transition: 0.1s;
        padding-bottom: 3px;
        border-bottom: solid 3px ${COLORS.border_and_text_blue};
      }
    }
  }
  //width =< 429px
  @media screen and (max-width: 429px) {
    justify-content: center;
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 20;
    .box-img-emohi {
      width: 35%;
      img {
        display: block;
        width: 100%;
        cursor: pointer;
      }
      .emoji-header {
        font-size: 1.5em;
      }
    }
    nav {
      display: none;
    }
  }
`;
